import React, { useState, useEffect } from 'react';

import Button from '@nexus/fff-ui-shared/Button';
import { getChainingJobStatus, runChainJob } from 'services/api/admin-refills';

import styles from './SubscriptionChaining.module.scss';

const SubscriptionChaining = () => {
  const [jobChainingData, setJobChainingData] = useState(null);

  const getChainingJobStatusData = async () => {
    try {
      const response = await getChainingJobStatus();
      setJobChainingData(response);
    } catch (err) {
      console.error(err);
    }
  };

  const onClickRunChaining = async () => {
    try {
      const res = await runChainJob();
      setJobChainingData(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getChainingJobStatusData();
  }, []);

  return (
    <div
      data-testid="subscription-chaining"
      className={styles.subscriptionChaining}
    >
      <h3>Subscription Chaining</h3>
      <div className={styles.subsChainingMetaContainer}>
        <div className={styles.subsChainingMetaLabels}>
          <p>Admin account code:</p>
          <p>Last run season:</p>
          <p>Status:</p>
          <p>Season:</p>
        </div>
        {jobChainingData && (
          <div className={styles.subsChainingMetaInfo}>
            <p>{jobChainingData.adminAccountCode}</p>
            <p>{jobChainingData.lastRanSeason}</p>
            <p>{jobChainingData.status}</p>
            <p>{jobChainingData.currentSeason}</p>
          </div>
        )}
      </div>
      <div className={styles.subsChainingActionBtns}>
        <Button
          variation="black-outline"
          onClick={onClickRunChaining}
          disabled={!jobChainingData || jobChainingData.status !== 'SUCCESS'}
          width="162px"
        >
          RUN CHAINING
        </Button>
        <Button
          variation="black-outline"
          onClick={getChainingJobStatusData}
          width="48px"
        >
          <i className="far fa-sync-alt" />
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionChaining;
